import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { DomSanitizer, SafeUrl, SafeHtml  } from '@angular/platform-browser';
import { AccountServiceProvider } from '../../providers/account-service/account-service';
import { Shareddata } from '../../providers/shareddata';
import { FuncsService } from '../../services/funcs.services';

@Component({
	selector      : 'app-news-detail',
	templateUrl   : './news-detail.component.html',
	encapsulation : ViewEncapsulation.None,
	host: {
		'(window:resize)': 'onResize($event)'
	}
})

export class NewsDetailComponent implements OnInit {
	public video_url?: SafeUrl;
	public news_detail              : any;
	public error_message            : any;
	public loadButton               : boolean = true;
	public error_message_show       : boolean = false;
	public isMobile                 : boolean;
	public i                        : number;
	public news_blurb_repeater      : any = [];
	public news_double_content_data : any = [];
	public news_file_data           : any = [];
	public news_wp_engage_data      : any = [];
	public news_result              : any;

	constructor(		
		private sanitizer      : DomSanitizer,
  		private accountService : AccountServiceProvider,
  		public shareddata      : Shareddata,
  		private funcs          : FuncsService,
	) {
		this.isMobile = this.funcs.globalDetectDevice();
		let current_slug = window.location.pathname.split("/").slice(-1)[0];
		let params = {
			'slug' : current_slug,
		};
		//Promise.all( [ this.accountService.getNewsDetail( params ) ] ).then( result => {
		this.accountService.getNewsDetail( params ).then( ( result: any ) => {
			this.news_detail = result;
			if ( 'Ok' === this.news_detail.status ) {
				if ( '404' != this.news_detail.type ) {
					if ( this.news_detail.seo_data ) {
						let alternateTitle = this.news_detail.title + ' | News';
						this.funcs.globalSeoData( this.news_detail, alternateTitle );
					}
					if ( this.news_detail.news_video != null ) {
						let url = 'https://www.youtube.com/embed/' + this.news_detail.news_video;
						this.video_url = this.sanitizer.bypassSecurityTrustResourceUrl( url );
					}
					this.loadButton = false;
					if ( this.news_detail.components ) {
						this.news_result = this.news_detail.components;
						for ( let entry of this.news_detail.components ) {
							if ( 'blurb_block' === entry.acf_fc_layout ) {
								this.news_blurb_repeater[ this.i ] = entry;
							}
							if ( 'double_content_column' == entry.acf_fc_layout ) {
								this.news_double_content_data[ this.i ] = entry;
							}
							if ( 'file_block' == entry.acf_fc_layout ) {
								this.news_file_data[ this.i ] = entry;
							}
							if ( 'wp_engage_block' == entry.acf_fc_layout ) {
								this.news_wp_engage_data[ this.i ] = entry;
							}
							if ( 'imagevideo_block' == entry.acf_fc_layout ) {
								if ( 'image' == entry.media_type )  {
									entry.image_display_type = 'media-display-' + entry.image_display_type;
								} else {
									entry.image_display_type = 'media-display-two_col';
								}
								if ( 'video' == entry.media_type ) {
									for ( let val of entry.media_video_repeater ) {
										val.iv_video_url = this.sanitizer.bypassSecurityTrustHtml( val.iv_video_url );
									}
								}
							}
							if ( 'simple_content_block' == entry.acf_fc_layout ) {
								// entry.scb_sb_content = this.sanitizer.bypassSecurityTrustHtml( entry.scb_sb_content );
								// entry.scb_content    = this.sanitizer.bypassSecurityTrustHtml( entry.scb_content );
							}
							this.i++;
						}
					}
				} else
					this.funcs.globalNavigate( '/404' );
			} else {
				this.error_message_show = true;
				if ( '3111' == result.errcode ) {
					this.error_message = 'Oops, looks like something went wrong!';
				} else {
					this.error_message = result['message'];
				}
				this.loadButton = false;
			}
		});
	}

	@HostListener('window:popstate', ['$event'])
	onPopState(event) {
		location.reload();
	}

	ngOnInit() {
		var headerClass = document.getElementsByClassName( 'header');
		if ( ! headerClass[0].classList.contains( 'inner_page_menu' ) )
			headerClass[0].classList.add( 'inner_page_menu' );
	}

	onResize(event) {
		this.addStyle();
	}

	ngAfterContentInit() {
		setTimeout (
			() => {
				this.addStyle();				
			}, 2000
		);
	}

	addStyle() {
		if ( document.querySelector( '.figure-type.out_of_boundary' ) && document.getElementById( 'out_of_boundary' ) ) {
			var outOfBoundary = document.querySelector( '.figure-type.out_of_boundary' ).getBoundingClientRect().left;
			document.getElementById( 'out_of_boundary' ).style.marginLeft = "-" + outOfBoundary + "px";
			document.getElementById( 'out_of_boundary' ).style.opacity = "1";
		}
	}
}